const API_URL = process.env.NEXT_PUBLIC_API_URL || ''

const BASE = API_URL + '/api/search'

export interface SearchResult {
  label: string
  desc: string
  category: string
  path: string
}

/**
 * Backend'den arama sonuçları çeker.
 * Boş query → popüler öğeler döner.
 */
export async function fetchSearchResults(query: string, limit = 12): Promise<SearchResult[]> {
  try {
    const params = new URLSearchParams()
    if (query) params.set('q', query)
    params.set('limit', String(limit))
    const res = await fetch(`${BASE}?${params}`)
    if (!res.ok) return []
    const data: SearchResult[] = await res.json()
    // BIST/Türkiye kaldırıldı — BIST hisseleri (category 'Türkiye') ve
    // BIST endeksleri (/piyasa/xu... gibi X ile başlayanlar) arama sonuçlarından gizlenir.
    return data.filter(r => r.category !== 'Türkiye' && !/^\/piyasa\/x/i.test(r.path))
  } catch {
    return []
  }
}
